<template>
  <div class="map-layers">
    <profile-tree
      :node-click-handler="toggleMapLayer"
      :toggle-tool="toggleTool"
      :is-active="isActiveLayer"
      :is-loading="isLoadingLayer"
      :dark-mode="true"
      :show-tools="true"
      module="mapTree"
    />
  </div>
</template>

<script>
import profileTree from "@/components/profiles-tree/profiles-tree.vue";
import { flyToOptions, openObjectInfo } from "@/utils";

export default {
  props: ["map", "layer-controller", "track-controller"],
  components: {
    profileTree
  },
  data() {
    return {
      needToCallLayer: null
    };
  },
  computed: {
    initialActiveLayers() {
      return this.$store.state.map.initialActiveLayers;
    },
    activeLayers() {
      return this.$store.state.map.activeLayers;
    },
    loadingLayers() {
      return this.$store.state.map.loadingLayers;
    },
    currentProfileTree() {
      return this.$store.state.profiles.currentProfileTree;
    },
    needToCallCard() {
      return this.$store.state.commonData.needToCallCard;
    }
  },
  methods: {
    checkNeedToCallCard() {
      if (!this.needToCallCard || !this.needToCallCard.sourcename) return;
      this.findCurrentLayer(
        this.currentProfileTree,
        this.needToCallCard.sourcename
      );
      if (!this.needToCallLayer) return;
      this.openCard(this.needToCallCard, this.needToCallLayer);
    },
    findCurrentLayer(tree, value) {
      tree.forEach(e => {
        if (!!e.children && !!e.children.length) {
          this.findCurrentLayer(e.children, value);
        }
        if (e.source_id === value) this.needToCallLayer = e;
      });
    },
    openCard(card, ds) {
      const sourcename = card.sourcename;

      if (this.initialActiveLayers.indexOf(sourcename) === -1)
        this.toggleMapLayer({}, ds);

      openObjectInfo(this, card.sourcename, card.id, "map");
      this.flyTo(card.id, card.sourcename);

      this.$store.commit("NEED_TO_CALL_CARD", {
        id: null,
        sourcename: null
      });
      this.needToCallLayer = null;
    },
    toggleMapLayer(_, layer) {
      if (layer.datatype === "last_tracks") {
        this.trackController.toggleLayer(layer);
        return;
      }

      if (
        layer.datatype === "model" ||
        (layer.children && layer.children.length)
      )
        return;
      this.layerController.toggleLayer(layer);
    },
    toggleTool(type, data) {
      switch (type) {
        case "settings":
        case "editor":
        case "traffic-counts":
          this.$emit("toggle-module", { type, data });
          break;
        case "fly-to-layer":
          this.flyToLayer(data.id);
          break;
      }
    },
    async flyTo(id, sourcename) {
      try {
        const config = JSON.stringify({
          only: ["id", "geom"],
          where: { field: "id", value: id, op: "=" }
        });
        const { data } = await this.$store.dispatch("REQUEST", {
          url: `objectInfo/${sourcename}?config=${config}`
        });
        const { geom } = data[id];
        this.$store.commit("SET_FLY_TO_GEOM", geom);
      } catch (error) {
        console.log(error);
      }
    },
    async flyToLayer(id) {
      const source_id = this.$store.state.profiles.sourceIdById[id];

      if (!this.$store.state.map.extent[source_id]) {
        const { data } = await this.$store.dispatch("REQUEST", {
          url: `geom_extent/${source_id}?`
        });
        const extent = data;
        this.$store.commit("SET_LAYER_EXTENT", { id: source_id, extent });
      }

      const extent = this.$store.state.map.extent[source_id];
      const { center, zoom } = this.map.cameraForBounds(
        [extent.slice(0, 2), extent.slice(2)],
        { padding: { top: 10, bottom: 10, left: 10, right: 10 } }
      );
      this.map.flyTo({
        center,
        zoom,
        ...flyToOptions
      });
    },
    isActiveLayer(id) {
      return this.activeLayers.indexOf(id) > -1;
    },
    isLoadingLayer(id) {
      return this.loadingLayers.indexOf(id) > -1;
    }
  },
  mounted() {
    this.$nextTick(() => this.checkNeedToCallCard());
  }
};
</script>

<style lang="scss">
.map-layers {
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  .tree-ds {
    height: calc(100% - 10px);
  }
}
</style>
